<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:15:09
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-06-02 17:18:33
 * @Description: 开工月报---整体统计
 -->
<template>
  <div class="work-sta-total">
    <part-title title="总体对比"></part-title>
    <div class="work-sta-total__chart-spot" ref="total-chart"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PartTitle from '@/components/part-title'
// import {
//   SPOT_LASTEST,
// } from '@/assets/const-value/interface'

export default {
  components: {
    PartTitle,
  },
  data() {
    return {
      totalChart: null,
    }
  },
  computed: {
    ...mapGetters({
      spotStaitstics: 'work/spotStaitstics',
    }),
  },
  watch: {
    spotStaitstics() {
      if (this.spotStaitstics && this.spotStaitstics.length) {
        this.setOption()
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.totalChart = this.$echarts.init(this.$refs['total-chart'])
    })
  },
  methods: {
    setOption() {
      const itemTotalArr = []

      const line = []
      const building = []
      const other = []
      const data = [ ...this.spotStaitstics ]
      let currentTotalNum = 0
      data.sort((a, b) => b.area - a.area).forEach((item) => {
        currentTotalNum += item.area
        line.push({ name: item.regionAlias, value: 0 })
        building.push({ name: item.regionAlias, value: 0 })
        other.push({ name: '其他', value: 0 })
        let itemValue = 0

        item.data.forEach((i) => {
          switch (i.type) {
            case '11':
              line[line.length - 1].value += i.area
              break
            case '12':
              building[building.length - 1].value += i.area
              break
            default:
              other[other.length - 1].value += i.area
          }
        })
        itemValue += item.area
        itemTotalArr.push(itemValue)
      })

      let maxValue = Math.max.apply(null, itemTotalArr) / currentTotalNum
      maxValue = Math.ceil(maxValue * 100 / 5) * 5 / 100

      let endPercent = Math.round(11 / line.length * 100)
      endPercent = endPercent > 100 ? 0 : endPercent
      const option = {
        color: [ '#D3DF49', '#5CC2CF', '#D662A1' ],
        grid: {
          top: 80,
          right: 35,
          left: 75,
          bottom: 80,
        },
        legend: {
          data: [ '道路交通类', '建筑类', '其他' ],
          right: 30,
          top: 20,
          textStyle: {
            fontFamily: 'PingFangSC-Regular,PingFang SC',
            fontSize: 16,
            color: '#737373',
            padding: [ 5, 0, 0, 0 ],
          },
          itemWidth: 20,
          itemHeight: 12,
        },
        xAxis: {
          type: 'category',
          data: line.map(i => i.name),
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
          axisLabel: {
            color: '#737373',
            rotate: 45,
            margin: 15,
            formatter: (value) => {
              if (value.length === 2) {
                return value.split('').join('    ')
              }
              return value
            },
            textStyle: {
              fontSize: 16,
              fontFamily: 'PingFangSC-Regular,PingFang SC',
            },
          },
        },
        yAxis: {
          name: '（%）',
          nameTextStyle: {
            fontSize: 16,
            color: '#737373',
            align: 'right',
            padding: [ 0, -5, 10, 0 ],
          },
          max: maxValue,
          boundaryGap: false,
          axisLabel: {
            color: '#737373',
            textStyle: {
              fontSize: 16,
              fontFamily: 'PingFangSC-Regular,PingFang SC',
            },
            formatter: value => value * 100,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#EFEFEF',
            },
          },
        },
        dataZoom: [
          {
            type: 'inside',
            realtime: true,
            start: 1,
            end: endPercent,
            xAxisIndex: [ 0 ],
            zoomOnMouseWheel: false,
            moveOnMouseWheel: true,
          },
          {
            type: 'slider',
            show: false,
            xAxisIndex: [ 0 ],
            filterMode: 'empty',
            width: '80%',
            height: 12,
            handleSize: 8,
            showDataShadow: false,
            bottom: '0%',
            left: '10%',
            start: 1,
            end: endPercent,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            borderColor: '#000036',
            backgroundColor: '#000036',
            fillerColor: '#1345AA',
            labelFormatter: '',
            zoomOnMouseWheel: false,
            moveOnMouseWheel: true,
          },
        ],
        tooltip: {
          trigger: 'axis',
          formatter: param => `${param[0].name} <br />
            ${param[2].marker} ${param[2].seriesName}：${Math.round((param[2].value) * 10000) / 100} <br />
            ${param[1].marker} ${param[1].seriesName}：${Math.round((param[1].value) * 10000) / 100} <br />
            ${param[0].marker} ${param[0].seriesName}：${Math.round((param[0].value) * 10000) / 100} <br />
            `,
        },
        series: [
          {
            type: 'bar',
            data: other.map(i => i.value / currentTotalNum),
            name: '其他',
            stack: '总量',
            barWidth: '20px',
            barGap: '100%',
            // emphasis: {
            //   itemStyle: {
            //     color: 'yellow',
            //   },
            // },
          },
          {
            type: 'bar',
            data: building.map(i => i.value / currentTotalNum),
            name: '建筑类',
            stack: '总量',
            barWidth: '20px',
            barGap: '100%',
            // emphasis: {
            //   itemStyle: {
            //     color: 'yellow',
            //   },
            // },
          },
          {
            type: 'bar',
            data: line.map(i => i.value / currentTotalNum),
            name: '道路交通类',
            stack: '总量',
            barWidth: '20px',
            barGap: '100%',
            // emphasis: {
            //   itemStyle: {
            //     color: 'yellow',
            //   },
            // },
          },
        ],
      }
      this.totalChart.setOption(option)
    },
  },
}
</script>

<style lang="scss">
.work-sta-total {
  position: relative;
  padding: 0 35px;
}

.work-sta-total__chart-spot {
  height: 400px;
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0,0,0,.2);
}
</style>
